import { RelatedEntitiesTile } from "web/components/Tiles"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "./TileSummarySettingsModal"

export default function AssetsSummaryTile({
  canEdit = true,
  isTemplate,
  overview,
  tileFetchParams,
  isDoubleColumn,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const emptyMessage = `There are no assets for this ${tile.parent_subject_type}`

  return (
    <RelatedEntitiesTile
      tileId={tileFetchParams.id}
      data={tile.data ? [tile.data] : []}
      fields={tile.fields}
      title={tile.name}
      overviewId={overview.id}
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      subjectType={tile.subject_type}
      breakoutLink={tile.breakout_link}
      emptyMessage={emptyMessage}
      isTemplate={isTemplate}
      canEdit={canEdit}
      isDoubleColumn={isDoubleColumn}
    />
  )
}
